



































































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { TextField } from '@/components/atoms';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import ModalOptions from '@/components/Modal/ModalOptions';
import { WelcomeCoinsPayload } from '@/models/sales-onboarding';

import eventBus from '@/utils/eventBus';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    Typography,
    Checkbox,
    TextField,
    CoinsIcon
  }
})
export default class WelcomeCoins extends Vue {
  @Prop() welcomeCoins!: WelcomeCoinsPayload;
  @Prop({ default: false }) welcomeCoinsWithoutCoins?: boolean;

  status = !!this.welcomeCoins.enabled;
  value = this.welcomeCoins.value;

  get coinExampleValue() {
    return 1;
  }

  onInput(value: string) {
    this.value = value;
    this.$store.dispatch('salesOnboarding/SET_FORM_DATA', {
      welcomeCoins: {
        enabled: this.status,
        value
      }
    });
  }

  openCoinsModal() {
    this.$emit('coins-modal-opened');

    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'offerFreeCoinsInstructionsModal',
        false,
        true,
        true,
        true,
        true
      ),
      { coinValue: this.coinExampleValue }
    );
  }

  changeToggle() {
    this.status = !this.status;

    segmentIo.track('Clicked on Toggle Welcome Coins (Ownership experience)', {
      status: this.status
    });

    if (!this.status) this.value = '';

    this.$store.dispatch('salesOnboarding/SET_FORM_DATA', {
      welcomeCoins: {
        enabled: this.status,
        value: !this.status ? '' : this.value
      }
    });
  }
}
